import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import getContrast from '@anm/helpers/color/getContrast';
import getDarkerColor from '@anm/helpers/color/getDarkerColor';
import getHSLColor from '@anm/helpers/color/getHSLColor';
import hex2rgba from '@anm/helpers/color/hex2rgba';
import { css } from 'styled-components';
export var layoutVariants = {
  pure: css(["background:#fff;"]),
  dawn: css(["background:linear-gradient( to bottom,", ",rgba(255,255,255,0) );"], function (_ref) {
    var playerColor = _ref.playerColor;
    return "".concat(hex2rgba(playerColor, 0.2));
  }),
  pale: css(["background:", ";"], function (_ref2) {
    var playerColor = _ref2.playerColor;
    return "".concat(hex2rgba(playerColor, 0.1));
  }),
  dusk: css(["background:linear-gradient( to bottom,rgba(255,255,255,0),", " );"], function (_ref3) {
    var playerColor = _ref3.playerColor;
    return "".concat(hex2rgba(playerColor, 0.2));
  }),
  deep: css(["background:", ";"], function (_ref4) {
    var playerColor = _ref4.playerColor;
    return "".concat(getHSLColor(playerColor));
  }),
  lily: css(["background:#fffdf8;"]),
  mist: css(["background:#dfe0e2;"]),
  sand: css(["background:#fcf6ed;"]),
  dew: css(["background:#f8f7f5;"]),
  peony: css(["background:#fbf1e7;"]),
  night: css(["background:#121212;"]),
  daisy: css(["background:#fffc71;"])
};
export var landingCTAVariants = {
  pure: css(["font-weight:bold;border-radius:5px;", ";"], function (_ref5) {
    var bgColor = _ref5.bgColor;
    return css(["background-color:", ";&:hover{background-color:", ";}"], bgColor, getDarkerColor(bgColor));
  }),
  dawn: css(["color:#fff;background-color:#292a2b;&:hover{background-color:#1b1c1d;}"]),
  pale: css(["border-radius:5px;font-weight:700;color:", ";", ";"], function (_ref6) {
    var bgColor = _ref6.bgColor;
    return "".concat(getContrast('#fff', bgColor) < 2 ? '#292A2B' : '#fff');
  }, function (_ref7) {
    var bgColor = _ref7.bgColor;
    return css(["background-color:", ";&:hover{background-color:", ";}"], bgColor, getDarkerColor(bgColor));
  }),
  dusk: css(["border:2px solid #292a2b;color:#292a2b;&:hover{background-color:", ";}"], hex2rgba('#292a2b', 0.05)),
  deep: css(["color:", ";background-color:#f5f7fa;&:hover{background-color:#e2e7f0;}"], function (_ref8) {
    var bgColor = _ref8.bgColor;
    return getHSLColor(bgColor);
  }),
  lily: css(["color:#292a2b;background-color:#5af5b2;&:hover{background-color:#50e1a8;}"]),
  mist: css(["background-color:#292a2b;&:hover{background-color:#1b1c1d;}"]),
  sand: css(["border:2px solid #c09850;color:#c09850;&:hover{background-color:#fff;}"]),
  dew: css(["color:#292a2b;border:2px solid #292a2b;border-radius:25px;&:hover{background-color:", ";}"], hex2rgba('#292a2b', 0.05)),
  peony: css(["color:#e39384;border:2px solid #e39384;&:hover{background-color:#f9e9da;}"]),
  night: css(["color:#292a2b;border-radius:5px;background-color:#f5f7fa;&:hover{background-color:#e2e7f0;}"]),
  daisy: css(["border:2px solid #292a2b;color:#292a2b;&:hover{background-color:", ";}"], hex2rgba('292a2b', 0.05))
};
export var textColorVariants = {
  pure: css([""]),
  dawn: css([""]),
  pale: css(["h1,p{color:", " !important;}"], function (_ref9) {
    var playerColor = _ref9.playerColor;
    return getHSLColor(playerColor, 100, 20);
  }),
  dusk: css([""]),
  deep: css(["h1,div,p{color:#fff !important;}"]),
  lily: css([""]),
  mist: css([""]),
  sand: css(["h1,p{color:#c09850;}"]),
  dew: css([""]),
  peony: css(["h1,p{color:#e39384 !important;}"]),
  night: css(["h1,div,p{color:#f5f7fa !important;}"]),
  daisy: css([""])
};
var light = {
  msgTime: '#575C5E',
  inputBg: '#333536',
  msgText: '#292A2B;',
  chatTitle: '#292A2B;',
  msgAuthor: '#575C5E',
  borderColor: '1px solid rgba(0, 56, 87, 0.2)',
  hideChatBtn: 'none',
  sendButtonFilter: 'invert(70%) sepia(28%) saturate(7403%) hue-rotate(172deg) brightness(101%) contrast(90%);',
  playerColor: DEFAULT_WAVE_COLOR
};
var dark = {
  inputBg: '#E0E7EB',
  msgTime: '#AAB3B9',
  msgText: '#F3F6F7',
  msgAuthor: '#AAB3B9',
  chatTitle: '#AAB3B9',
  hideChatBtn: 'invert(79%) sepia(10%) saturate(225%) hue-rotate(161deg) brightness(91%) contrast(83%)',
  borderColor: 'border: 1px solid rgba(255, 255, 255, 0.2)',
  sendButtonFilter: 'invert(43%) sepia(72%) saturate(2833%) hue-rotate(175deg) brightness(95%) contrast(95%)',
  playerColor: DEFAULT_WAVE_COLOR
};
export var getWebinarColorsByTheme = function getWebinarColorsByTheme(theme) {
  return {
    pure: light,
    dawn: light,
    pale: light,
    dusk: light,
    deep: _objectSpread(_objectSpread({}, dark), {}, {
      playerColor: '#F46BB3'
    }),
    lily: _objectSpread(_objectSpread({}, light), {}, {
      playerColor: '#B47BBA'
    }),
    mist: _objectSpread(_objectSpread({}, light), {}, {
      playerColor: '#1877F2'
    }),
    sand: _objectSpread(_objectSpread({}, light), {}, {
      playerColor: '#6A635D'
    }),
    dew: _objectSpread(_objectSpread({}, light), {}, {
      playerColor: '#3B6B4E'
    }),
    peony: _objectSpread(_objectSpread({}, light), {}, {
      playerColor: '#B47468'
    }),
    night: _objectSpread(_objectSpread({}, dark), {}, {
      playerColor: '#3F4244'
    }),
    daisy: _objectSpread(_objectSpread({}, light), {}, {
      playerColor: '#292A2B'
    })
  }[theme];
};